module.exports = __webpack_public_path__ + "40e83fff54376bb6dc5df306716bbab8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Yummy/images/backgrounds/6.png
// module id = 36
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18